export default __webpack_public_path__ + "static/media/nextIcon.c7dec4a0.svg";